<template>
  <div class="base-dialog" v-show="innerVisible">
    <div class="back-drop" @click="close"></div>
    <div class="base-dialog-body">
      <div class="dialog-header">
        <div class="header-title">{{ title }}</div>

        <img
          class="icon-close"
          @click="close"
          src="../../../assets/imgs/work-wx/common/close.png"
        />
      </div>
      <div class="dialog-content">
        <slot></slot>
      </div>
      <div v-if="!hideFooter" class="dialog-footer">
        <slot name="footer">
          <button class="cancel-btn" @click="close">取消</button>
          <button
            class="confirm-btn"
            :disabled="confirmLoading"
            @click="confirm"
          >
            确认
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    visible: Boolean,
    title: String,
    hideFooter: {
      type: Boolean,
      value: false,
    },
    confirmLoading: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  created() {},
  methods: {
    close() {
      this.innerVisible = false;
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="less" scoped>
.base-dialog {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1000;
  .back-drop {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: fade(#000000, 40);
    z-index: 1;
  }
  .base-dialog-body {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 90vw;
    background-color: white;
    border-radius: 4px;
    overflow: hidden;
    .dialog-header {
      width: 100%;
      border-bottom: 1px solid #dee3f0;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 14px;
      position: relative;
      &::before {
        content: '';
        width: 4px;
        height: 18px;
        background: #3fa2f5;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .header-title {
        color: #2c3344;
        font-size: 16px;
        font-weight: 600;
      }
      .icon-close {
        height: 14px;
        width: 14px;
        cursor: pointer;
      }
    }
    .dialog-content {
      max-height: 60vh;
      overflow: auto;
      padding: 20px;
    }
    .dialog-footer {
      padding: 0 20px 20px 20px;
      display: flex;
      justify-content: flex-end;
      .cancel-btn,
      .confirm-btn {
        width: 80px;
        height: 34px;
        border-radius: 2px;
        border: 1px solid #dee3f0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #717785;
        font-size: 14px;
        background: #fff;
        &[disabled] {
          opacity: 0.7;
          cursor: not-allowed;
        }
      }
      .confirm-btn {
        border: none;
        background: #3fa2f4;
        color: #fff;
        margin-left: 12px;
      }
    }
  }
}
</style>
